import PropTypes from 'prop-types'
import { Fragment } from 'react'
import {
  Asset,
  Conditional,
  renderIcon,
  kuiperClassNames,
} from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import {
  sharedColors,
  sharedStyles,
} from '../../../sharedDisplays/sharedStyles'
import { addComment, timestamp } from '../../../sharedDisplays/staticText'
import { TextAreaWithAccountName } from '../../../sharedDisplays/TextAreaWithAccountName'
import { styles } from './styles'

export const DesktopStream = ({
  accountImage,
  accountName,
  asset,
  collabAccount,
  content = '',
  instagramCollab,
  isPresenting,
  location,
  maintainAspectRatio = false,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  truncate = false,
  updateCaption,
}) => {
  const renderResponseIcon = (glyph) =>
    renderIcon(glyph, { width: 24, height: 24, ariaMode: 'hidden' })

  const getSecondAccountProps = (collabAccount) => ({
    name: collabAccount || 'No collab account',
    color: collabAccount ? 'inherit' : sharedColors.emptyCollab,
    style: collabAccount ? styles.accountNameStyles : styles.emptyCollabStyles,
  })

  return (
    <div css={styles.flexColumn}>
      <div css={styles.header} className={kuiperClassNames('instagram-header')}>
        <div css={styles.avatarUsername(location, 'desktopStream')}>
          {instagramCollab ? (
            <Fragment>
              <div css={sharedStyles.collabAvatarStyles}>
                <ContentAvatar assetReference={accountImage} size={24} />
                <ContentAvatar
                  assetReference={null}
                  size={24}
                  style={sharedStyles.secondAvatarStyles}
                />
              </div>
              <div css={styles.accountNameWrapperStyles}>
                <AccountName
                  name={accountName}
                  style={styles.accountNameStyles}
                />
                <span> and </span>
                <AccountName {...getSecondAccountProps(collabAccount)} />
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <ContentAvatar
                assetReference={accountImage}
                style={styles.avatar}
              />
              <AccountName
                name={accountName}
                color={sharedColors.darkGreyText}
              />
            </Fragment>
          )}
          <Conditional condition={location}>
            <span
              css={styles.location}
              className={kuiperClassNames('instagram-location')}
            >
              {location}
            </span>
          </Conditional>
        </div>
        {renderIcon('instagram-desktop-more', { ariaMode: 'hidden' })}
      </div>
      <Asset
        imageFit="cover"
        hasAssetOptions={true}
        hasAssetOverlay={Boolean(asset) && (!readOnly || isPresenting)}
        assetReference={asset}
        placeholder={true}
        removeable={!isPresenting}
        onEmbiggen={() => onExpandAsset(asset.id)}
        onRemove={() => onRemoveAsset(asset.id)}
        updateCaption={updateCaption}
        overrideStyles={{
          asset: styles.makeAssetStyles(maintainAspectRatio),
          assetBase: styles.makeAssetBaseStyles(maintainAspectRatio),
        }}
      />
      <ul css={styles.responseList}>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderResponseIcon('instagram-mobile-heart')}
        </li>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderResponseIcon('instagram-mobile-comment')}
        </li>
        <li css={styles.responseItem({ bookmark: false })}>
          {renderResponseIcon('instagram-mobile-send')}
        </li>
        <li css={styles.responseItem({ bookmark: true })}>
          {renderResponseIcon('instagram-mobile-bookmark')}
        </li>
      </ul>
      <div
        css={styles.contentWrapper}
        className={kuiperClassNames('instagram-textarea-wrapper')}
      >
        <TextAreaWithAccountName
          content={content}
          display="desktopStream"
          readOnly={readOnly}
          isPresenting={isPresenting}
          onContentChange={onContentChange}
          contentCharacterLimit={2200}
          accountMeasurerStyle={styles.accountMeasurer}
          textareaStyle={styles.textarea}
          truncate={truncate}
          truncationLimit={125}
          username={accountName}
        />
      </div>
      <div
        css={styles.postedAt}
        className={kuiperClassNames('instagram-posted-at')}
      >
        {timestamp}
      </div>
      <div
        css={styles.addCommentText}
        className={kuiperClassNames('instagram-add-comment')}
      >
        {addComment}
      </div>
    </div>
  )
}

DesktopStream.propTypes = {
  accountImage: PropTypes.object,
  accountName: PropTypes.string,
  asset: PropTypes.object,
  collabAccount: PropTypes.string,
  content: PropTypes.string,
  instagramCollab: PropTypes.bool,
  isPresenting: PropTypes.bool,
  location: PropTypes.string,
  maintainAspectRatio: PropTypes.bool,
  onContentChange: PropTypes.func,
  onExpandAsset: PropTypes.func,
  onRemoveAsset: PropTypes.func,
  readOnly: PropTypes.bool,
  truncate: PropTypes.bool,
  updateCaption: PropTypes.func,
}
